import { Stack } from '@mantine/core';
import FileItem from '@/pages/AutomationPage/components/ManualRunModal/components/FileItem';
import type { RelativeFile } from '@/types/common';
import CustomDropZone from '@/components/CustomDropZone';

type Props = {
  files: RelativeFile[];
  setFiles: (_files: RelativeFile[], _name?: string) => void;
};

export default function UploadMultiFiles({ files, setFiles }: Props) {
  return (
    <Stack gap="xs">
      <CustomDropZone mode="multiple" files={files} setFiles={setFiles} />

      {files.map((f, idx) => (
        <FileItem
          key={`${f.file.name}-${idx}`}
          name={f.path}
          size={f.file.size}
          onDelete={() => {
            const next = files.slice();
            next.splice(idx, 1);
            setFiles(next);
          }}
        />
      ))}
    </Stack>
  );
}
